import { StateMasterService } from "@/api/services/masterService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Define types for State
interface State {
    stateCode: string;
    stateName: string;
    gstCode: number;
    countryId: string;
    countryName: string;
    id: string;
    status: number;
  }

// Define state type
interface StateMasterState {
  loading: boolean;
  StateList: State[];
  error?: string;
}

// Initial state with type safety
const initialState: StateMasterState = {
  loading: false,
  StateList: [],
  error: undefined,
};

// ✅ Fixed Async thunk with proper return type
export const fetchStateMaster = createAsyncThunk<
  State[], 
  void, 
  { rejectValue: string }
>(
  "State/fetchStateMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await StateMasterService.getall();
console.log(response.data,"ppppppp");

      // If API returns { data: State[] }, extract `data`
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch State data");
    }
  }
);

// Create slice with strong typing
const StateMasterSlice = createSlice({
  name: "StateMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchStateMaster.fulfilled, (state, action: PayloadAction<State[]>) => {
        state.StateList = action.payload;
        state.loading = false;
      })
      .addCase(fetchStateMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// Export reducer
export default StateMasterSlice.reducer;
